module.exports = __webpack_public_path__ + "img/add-to-apple-wallet-logo2.b9d2c660.png";